<template>
    <v-form class="power-setting-block" kind="desc" size="small">
        <v-form-item
            v-for="item of value"
            :key="item.permission_id"
            class="power-setting-block-item"
            :name="item.name"
            :label="item.name"
        >
            <div
                v-if="item.permission_scope.length === 0"
                class="power-setting-block-item-value is-empty"
            >
                <!-- <VmSelectBusinessPopper
                    ref="second"
                    :config="getConfigByItem(item)"
                    @submit="data => onVmSelectSubmit(data, item)"
                >
                    <span class="power-setting-block-add-btn">添加</span>
                </VmSelectBusinessPopper> -->
                <OrgSelect
                    mode="dialog"
                    :use-big-tree="true"
                    :check-strictly="true"
                    :single="false"
                    :with-checkbox="false"
                    :depart-can-select="true"
                    :selected="selected(item)"
                    :cust-fetch-tree="adapteOldCgi()"
                    @confirm="data => handleSelectConfirm(data, item)"
                >
                    <v-button slot="trigger" type="link" kind="primary">
                        <v-icon remote name="basic_new_line" />
                        添加
                    </v-button>
                </OrgSelect>
            </div>
            <div
                v-else
                class="power-setting-block-item-value"
            >
                <span
                    class="power-setting-block-item-status-statistics"
                    >
                    共{{ depCount(item) }}个部门和{{ staffCount(item) }}名员工
                </span>
                <PowerRangeList
                    :list="item.permission_scope"
                    @onDelete="handleDelete"
                />
                <div class="power-setting-block-item-status">
                    <!-- <VmSelectBusinessPopper
                        ref="second"
                        :config="getConfigByItem(item)"
                        @submit="data => onVmSelectSubmit(data, item)"
                    >
                        <span class="power-setting-block-add-btn">添加</span>
                    </VmSelectBusinessPopper> -->
                    <OrgSelect
                        mode="dialog"
                        :use-big-tree="true"
                        :check-strictly="true"
                        :single="false"
                        :with-checkbox="false"
                        :depart-can-select="true"
                        :selected="selected(item)"
                        :cust-fetch-tree="adapteOldCgi()"
                        @confirm="data => handleSelectConfirm(data, item)"
                    >
                        <v-button slot="trigger" type="link" kind="primary">
                            <v-icon remote name="basic_new_line" />
                            添加
                        </v-button>
                    </OrgSelect>
                </div>
            </div>
        </v-form-item>
    </v-form>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import OrgSelect from 'src/components/org-select';
import adapteOldCgi from '@/components/org-set/adapteOldCgi';
// import VmSelectBusinessPopper from '@/components/vm-select-business-popper';

import PowerRangeList from './PowerRangeList';

export default {
    components: {
        PowerRangeList,
        OrgSelect,
        // VmSelectBusinessPopper
    },
    props: {
        value: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    methods: {
        onVmSelectSubmit(data, target) {
            console.log(data, target);
            const { colleague } = data || {};
            if (colleague && colleague.length > 0) {
                target.permission_scope = this.transformSelectorToData(colleague);
                // this.selectedMemberList = colleague.map(item => item.id);
                // this.addMember();
            }
        },
        getConfigByItem(item) {
            return {
                tabs: {
                    // 同事数据源标识
                    colleague: {
                        selected: this.selected(item), // 默认已选id
                        checkStrictly: true, // 严格模式，父子不相关
                    },
                },
                multiple: true, // 多选/单选
                maxLength: 0, // 最大可选数 ，0 表示不限制,
                layout: {
                    search: true, // 是否展示搜索，默认true
                    list: true, // 是否展示列表 默认true
                    status: true, // 是否展示已选数。默认 true
                    action: true, // 是否展示 “确认/取消” 。默认 true
                    selected: true, // 是否展示已选列表， 默认true
                },
                withCheckbox: false, // 是否展示checkbox
            };
        },

        transformDataToSelector(list) {
            return list.map((item) => {
                const isFolder = item.type === 0;
                const common = {
                    id: item.id,
                    name: item.name,
                };
                if (isFolder) {
                    return {
                        ...common,
                        isFolder: item.type === 0,
                    };
                }
                return {
                    ...common,
                    gender: Number(item.gender),
                };
            });
        },
        transformSelectorToData(list) {
            return list.map(item => ({
                id: item.id,
                name: item.name,
                gender: Number(item.gender),
                type: item.isFolder ? 0 : 1,
            }));
        },
        selected(item) {
            return this.transformDataToSelector(cloneDeep(item.permission_scope));
        },
        handleSelectConfirm(list, target) {
            target.permission_scope = this.transformSelectorToData(list);
        },
        handleAdd(target) {
            console.log(target);
            // this.$emit('onAdd', target);
        },
        depCount(target) {
            return target.permission_scope.filter(itm => itm.type === 0).length;
        },
        staffCount(target) {
            return target.permission_scope.filter(itm => itm.type === 1).length;
        },
        handleDelete({ index, parent }) {
            parent.splice(index, 1);
        },

        adapteOldCgi,
    },
};
</script>

<style lang="less">
.power-setting-block {
    margin: 36px 0 80px 0;
    &-add-btn {
        font-size: 14px;
        line-height: 20px;
        color: #0067ed;
        cursor: pointer;
    }
    &-item {
        display: flex;
        align-items: baseline;
        &:not(:first-child) {
            margin-top: 30px;
        }
        &-label {
            width: 130px;
            flex-shrink: 0;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            color: #1e2330;
        }
        &-value {
            flex: auto;
            width: 100%;
        }
        &-status {
            display: flex;
            align-items: center;
            margin-top:  var(--spacing-tight);
            &-statistics {
                display: inline-block;
                margin-right: 10px;
                margin-bottom:  var(--spacing-tight);
                color: var(--color-text-caption);
            }
        }
    }
}
</style>
